var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"created-label"},[_vm._v(_vm._s(_vm.t == 1 ? this.$t("Təyin_olunmayıb:") : this.$t("Yadda_saxlanıb"))+" : "+_vm._s(_vm.c))])])}
var staticRenderFns = []

export { render, staticRenderFns }